import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const Header = styled.div`
  width: 100%;
  height: 9vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${colors.BLACK};
  color: ${colors.WHITE};
  font-family: quicksand;
  font-weight: bold;
  font-size: 1.5rem;
`;

export const BackContainer = styled.div`
  position: absolute;
  height: 100%;
  left: 1vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5vw;
  font-size: 1.25rem;
  font-family: quicksand;
  font-weight: bold;
  cursor: pointer;
`;

export const Main = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${colors.BLUE_GRAY};
  box-sizing: border-box;
`;

export const LessonContainer = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  width: 75%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 1rem 0;
  align-items: center;
  background: ${colors.WHITE};
  border-radius: 1rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
`;

export const VideoContainer = styled.div`
  width: 90%;
  height: 75%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideoInfo = styled.div`
  width: 100%;
  height: 15%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  margin-left: 6vw;
`;

export const VideoTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  font-family: quicksand;
  font-weight: bold;
  font-size: 2vw;
`;

export const SideBar = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${colors.WHITE};
  box-sizing: border-box;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const videoStyle = { width: 'auto', height: '100%' };

export const audioStyle = { width: '100%' };

export const courseTitle = { fontFamily: 'quicksand', fontSize: '1.5rem' };

export const authorStyle = { fontFamily: 'quicksand', fontSize: '1.25vw' };

export default {
  Header,
  BackContainer,
  Main,
  LessonContainer,
  VideoContainer,
  VideoInfo,
  VideoTitle,
  SideBar,
  videoStyle,
  audioStyle,
  courseTitle,
  authorStyle,
};
